export const enClientPortalErrorHandlersErrors = {
    forbidden: {
        headline: 'Missing permission',
        detail: 'If the error persists, please contact our support at support@einwert.com.',
    },
    unauthorized: {
        headline: 'Authentication required',
        detail: 'Please sign in again. If the problem persists, please contact our support at support@einwert.com.',
    },
    missingToken: {
        headline: 'Authentication required',
        detail: 'Your session has expired. Please sign in again.',
    },
    externalParticipantEmailBelongsToManagedUser: {
        headline: 'This person cannot be added as an external appraiser',
        detail: 'This email address already belongs to an einwert account. Please contact our support at support@einwert.com.',
    },
    frontend: {
        headline: 'Something went wrong.',
    },
    unexpected: {
        headline: 'An unexpected error occurred.',
    },
}
